import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button"; // Make sure you have @mui/material installed
import { useLocation, useNavigate } from "react-router";
import getLocalStorageData from "../../utlis/storageUtils";
import Rabbit from "rabbit-node/lib/rabbit";

const OtpVerify = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessBtn, setShowSuccessBtn] = useState(false); // new state
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  const location = useLocation();
  const transId = location.state?.transId; // get transId passed via navigate
  const payment_id = location.state?.paymentId;

  const phone = getLocalStorageData();  //getLocalStorageData
  // const payment_id = "SNS_99S";
  const payment_name = "TELENOR";
  const trans_id = transId;

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) inputRefs.current[index - 1].focus();
      else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.includes("")) {
      setMessage("Please enter all 6 digits.");
      return;
    }

    const code = otp.join("");
    const payload = {
      udid: null,
      phone,
      payment_id,
      payment_name,
      amount: "",
      version_code: "web",
      version_name: "web",
      code,
      trans_id,
    };

    try {
      setLoading(true);
      setMessage("");
      setShowSuccessBtn(false);

      const response = await axios.post(
        "https://apiv2.shwenarsin.com/api/payment/telenor/otp/verify",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.status === 1) {
        setMessage(response.data.message);
        setShowSuccessBtn(true); // show button when status is 1
        setOtp(new Array(6).fill("")); // clear all input fields
        inputRefs.current[0]?.focus(); // focus the first input
      } else {
        setMessage("OTP verification failed.");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error verifying OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = () => {
    setOtp(new Array(6).fill(""));
    inputRefs.current[0]?.focus();
    setMessage("OTP has been resent!");
    setShowSuccessBtn(false); // hide success button on resend
  };

  const handleSuccessBtn = () => {
    // closeModal();
    // setModalActions(null);
    // setModalBody(null);
    navigate("/");
  };

  return (
    <div style={styles.container}>
      <h2>Verify OTP</h2>
      <p> သင်၏ဖုန်းနံပတ်သို့ SMS ဖြင့်ရောက်ရှိလာသော ကုဒ် ၆ လုံးကို ရိုက်ထည့်ပေးပါ။ </p> 

      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.otpInputs}>
          {otp.map((digit, index) => (
            <input
              key={index}
              type="tel"             // triggers number keypad on mobile
              inputMode="numeric"    // helps ensure numeric keyboard
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputRefs.current[index] = el)}
              style={styles.input}
              disabled={loading}
            />
          ))}
        </div>

        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? "Verifying..." : "Verify"}
        </button>
      </form>


      {/* <button
        onClick={handleResend}
        style={styles.resendButton}
        disabled={loading}
      >
        Resend OTP
      </button> */}

      {message && <p style={styles.message}>{Rabbit.zg2uni(message)}</p>}

      {showSuccessBtn && (
        <Button
          size="small"
          variant="contained"
          disableRipple
          onClick={handleSuccessBtn}
          sx={{
            marginTop: "20px",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingRight: "50px",
            paddingLeft: "50px",
            borderRadius: "10px",
            backgroundColor: "#facc15",
            color: "black",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#eab308",
              borderColor: "#eab308",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none",
              backgroundColor: "#facc15",
              borderColor: "#ca8a04",
            },
          }}
        >
          အခုပဲနားထောင်မည်
        </Button>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "30px",
    border: "1px solid #ccc",
    borderRadius: "10px",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginTop: "20px",
  },
  otpInputs: {
    display: "flex",
    justifyContent: "space-between",
  },
  input: {
    width: "50px",
    height: "50px",
    textAlign: "center",
    fontSize: "24px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    color: "black",
  },
  button: {
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  resendButton: {
    marginTop: "15px",
    padding: "8px",
    backgroundColor: "#f0f0f0",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    color: "#333",
  },
  message: {
    marginTop: "15px",
    color: "green",
    fontWeight: "bold",
  },
};

export default OtpVerify;
